import jsPDF from "jspdf";
import logo from "../logo.png";

/**
 * Generates a professional training completion certificate as a PDF.
 * @param {Object} data - The assignment data including employee and training details.
 */
export const generateCertificate = (data) => {
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4"
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // 1. Add Watermark (Logo centered with low opacity)
    try {
        doc.saveGraphicsState();
        doc.setGState(new doc.GState({ opacity: 0.1 }));
        // Center a large logo in the middle
        const logoSize = 100;
        doc.addImage(logo, 'PNG', (pageWidth - logoSize) / 2, (pageHeight - logoSize) / 2, logoSize, logoSize, undefined, 'FAST');
        doc.restoreGraphicsState();
    } catch (e) {
        console.warn("Logo watermark failed:", e);
    }

    // 2. Add Border
    doc.setDrawColor(13, 110, 253); // Professional Blue
    doc.setLineWidth(2);
    doc.rect(5, 5, pageWidth - 10, pageHeight - 10);
    doc.setLineWidth(0.5);
    doc.rect(7, 7, pageWidth - 14, pageHeight - 14);

    // 3. Decorative Corners
    doc.setFillColor(13, 110, 253);
    doc.triangle(5, 5, 25, 5, 5, 25, 'F');
    doc.triangle(pageWidth - 5, 5, pageWidth - 25, 5, pageWidth - 5, 25, 'F');
    doc.triangle(5, pageHeight - 5, 25, pageHeight - 5, 5, pageHeight - 25, 'F');
    doc.triangle(pageWidth - 5, pageHeight - 5, pageWidth - 25, pageHeight - 5, pageWidth - 5, pageHeight - 25, 'F');

    // 4. Header Text
    doc.setTextColor(33, 37, 41);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(40);
    doc.text("ASIAN CLIMATE CONTROLS", pageWidth / 2, 40, { align: "center" });

    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("Sriperumbudur", pageWidth / 2, 48, { align: "center" });

    // 5. Main Title
    doc.setTextColor(13, 110, 253);
    doc.setFontSize(32);
    doc.setFont("helvetica", "bold");
    doc.text("CERTIFICATE OF COMPLETION", pageWidth / 2, 75, { align: "center" });

    // 6. Body Text
    doc.setTextColor(73, 80, 87);
    doc.setFontSize(16);
    doc.setFont("helvetica", "italic");
    doc.text("This is to certify that", pageWidth / 2, 95, { align: "center" });

    // 7. Employee Name
    doc.setTextColor(33, 37, 41);
    doc.setFontSize(28);
    doc.setFont("helvetica", "bold");
    doc.text(data.employeeName.toUpperCase(), pageWidth / 2, 110, { align: "center" });
    // Line removed per apparent request to "remove the line"

    // 8. Course Mention
    doc.setTextColor(73, 80, 87);
    doc.setFontSize(16);
    doc.setFont("helvetica", "italic");
    doc.text("has successfully completed the training program", pageWidth / 2, 130, { align: "center" });

    doc.setTextColor(13, 110, 253);
    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    doc.text(data.trainingName, pageWidth / 2, 145, { align: "center" });

    // 9. Footer Info (Centered Completion Date)
    doc.setTextColor(108, 117, 125);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Completion Date: ${data.scheduledDate}`, pageWidth / 2, pageHeight - 12, { align: "center" });

    // 10. Signatures
    doc.setDrawColor(33, 37, 41);
    doc.setLineWidth(0.5);
    doc.line(40, 160, 90, 160);
    doc.line(pageWidth - 90, 160, pageWidth - 40, 160);

    doc.setTextColor(33, 37, 41);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Training Coordinator", 65, 168, { align: "center" });
    doc.text("Authorized Signatory", pageWidth - 65, 168, { align: "center" });

    // Save PDF
    doc.save(`Certificate_${data.employeeName.replace(/\s+/g, '_')}_${data.trainingName.replace(/\s+/g, '_')}.pdf`);
};
